import { useContext, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";

export default function OneProject({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'clients',
      extraItem: data.uuid,
    });
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "24px",
        padding: "20px 32px",
        cursor: "pointer",
        background: "rgba(0, 0, 0, 0.02)",
        borderRadius: "16px",
        transition: "all 0.3s ease",
        border: "1px solid",
        borderColor: "rgba(0,0,0,0.05)",
      }}
      className="mt-3"
    >
      {/* Logo Left */}
      <div 
        style={{
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "all 0.4s ease",
          transform: "scale(1.05)"
        }}
      >
        <img 
          src={(CDN_URL + data.coverPhoto)} 
          alt={data.title}
          style={{ 
            maxWidth: "100%", 
            maxHeight: "100%", 
            objectFit: "contain" 
          }}
        />
      </div>

      {/* Name Right */}
      <div style={{ flex: 1 }}>
        <h4 
          style={{
            color: "#000",
            margin: 0,
            fontSize: "1.2rem",
            fontWeight: "600",
            letterSpacing: "-0.01em",
            transition: "color 0.3s ease"
          }}
        >
          {data.title}
        </h4>
        <div 
          style={{
            height: "2px",
            width: "40px",
            background: "#3b82f6",
            marginTop: "6px",
            transition: "width 0.3s ease"
          }} 
        />
      </div>
    </div>
  );
}